export const extractQueryParameterFromURL = (parameterName) => {
  try {
    // First, check query parameters (after question mark (?))
    const urlObject = new URL(window.location.href);
    const queryParams = new URLSearchParams(urlObject.search);
    let paramValue = queryParams.get(parameterName);

    // If not found in query params, check hash parameters
    if (!paramValue && window.location.hash) {
      let hash = window.location.hash.substring(1); // Remove the # symbol

      // Handle case where hash starts with / (like #/id_token=...)
      if (hash.startsWith("/")) {
        hash = hash.substring(1); // Remove the leading /
      }

      // Split by & and look for the parameter
      const hashParts = hash.split("&");
      for (const hashPart of hashParts) {
        if (hashPart.includes("=")) {
          const [key, ...valueParts] = hashPart.split("=");
          const value = valueParts.join("=");
          if (key === parameterName) {
            paramValue = decodeURIComponent(value);
            break;
          }
        }
      }
    }

    return paramValue;
  } catch (error) {
    console.error(`Error in extracting ${parameterName} => `, error);
    return null;
  }
};
